import { getRequest } from "./utils";

const $ = window.jQuery;

export function getContent(dateRange, page = 0) {
	getRequest("/search/", {
		page,
		dateRange,
	}).then(
		response => {
			if (response.html) {
				$("#js-event-items").html(response.html);
				$(".date__show-no-result").hide();
			} else {
				$("#js-event-items").html("");
				$(".date__show-no-result").show();
				$(".date__show-text").hide();
				$(".date__field").hide();
			}
		},
		error => {
			console.error(error);
		},
	);
}
